import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const webBannerApi = createAsyncThunk("webBanner", async () => {
  const response = await axiosInstance.get(`/table/web_banner`);
  return response.data;
});

const webBannerSlice = createSlice({
  name: "webBanner",
  initialState: {
    webBanner: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(webBannerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(webBannerApi.fulfilled, (state, action) => {
        state.webBanner = action.payload;
        state.loading = false;
      })
      .addCase(webBannerApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default webBannerSlice.reducer;
